import { updateProfileDataThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import { TrashSquareIcon } from '../../../../../assets/icons/common';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './styles.module.scss';
import { useEffect } from 'react';
import {
    selectProfileData,
    selectSelectedExpertise,
    selectUpdatingProfileData,
} from '../../../../../store/workspace/selectors';
import {
    setSelectedExpertise,
    setDeleteExpertiseModal,
} from '../../../../../store/workspace/slice';

export default function DeleteExpertise() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const isLoading = useSelector(selectUpdatingProfileData);
    const selectedExpertise = useSelector(selectSelectedExpertise);

    useEffect(() => {
        return () => {
            dispatch(setSelectedExpertise(null));
        }
    }, []);

    const submit = () => {
        if (!profile) return;
        const { kyc, matchedJobs, setting, ...rest } = profile;
        const filteredList = profile.experties.filter(i => i.expert.id !== selectedExpertise?.expert.id);
        dispatch(updateProfileDataThunk({ ...rest, experties: [...filteredList] }));
    };

    return (
        <Modal
            size='sm'
            title='Delete expertise'
            icon={<TrashSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setDeleteExpertiseModal(false))}
        >
            <h3>Are you sure you want to delete "{selectedExpertise?.expert.title}" ?</h3>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setDeleteExpertiseModal(false))}
                />
                <Button
                    type='Error'
                    text='Delete'
                    onClick={submit}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
